module.exports = __webpack_public_path__ + "img/tests-and-surveys.6b02486.webp";